import React, { useState } from 'react'
import Header from '../Common/Header'
import TopSection from '../Common/TopSection';
import ModalLayoutNew from '../Modals/ModalLayoutNew';
import NewAppraisalModal from '../Modals/NewAppraisalModal';

const Layout = ({children, hideTopBar, tabClick}) => {
  const [openNewAppraisal, setOpenNewAppraisal] = useState(false);
  const handleNewAppraisal = () => {
      setOpenNewAppraisal(true);
      document.body.classList.add('overflow-body');
  }
  const closeNewAppraisal = () => {
      setOpenNewAppraisal(false);
      document.body.classList.remove('overflow-body');
  }

  return (
    <>
        <Header/>
        {!hideTopBar &&
          <TopSection handleNewAppraisal={handleNewAppraisal} tabClick={tabClick}/>
        }
        {children}

        <ModalLayoutNew open={openNewAppraisal} close={closeNewAppraisal}  darkThemeCls='true' modalWidth={1198}>
          <NewAppraisalModal 
            close={closeNewAppraisal} appraisalStage={"NewLead"} 
            leadType={"EQR"}
          />
        </ModalLayoutNew>


        
    </>
  )
}

export default Layout